import React from 'react';

export const ReactKeycloakContext = React.createContext(null);

export default ReactKeycloakContext;
